import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Box } from '@mui/material';
import { RequerimentoPesquisa } from '../Requerimento/Pesquisa/RequerimentoPesquisa';
var HomePage = function () {
    return (_jsx(Box, { children: _jsx(RequerimentoPesquisa, {}) }));
};
export default HomePage;
